import {FC} from 'react';

import Company from '../../components/Companies/CompaniesTable/Company';

const CompanyPage: FC = () => {
  return (
    <div>
      <Company />
    </div>
  );
};

export default CompanyPage;
